import { sortBy, assign } from 'lodash';
import { EventEmitter } from 'events';

var Dispatcher = require('../dispatcher/appDispatcher');
var ActionType = require('../constants/actionType');

var CHANGE_EVENT = 'change';

var _recentSessions = [],
  _latestSessions = [],
  _learnerId = null,
  _assessmentDetails = {},
  _miscueTypes = [],
  _miscueYearGroups = [],
  _miscueBookBands = [];


var MiscueSessionStore = assign({}, EventEmitter.prototype, {

  isHiddenYearGroup(code){
    return code == 1000;
  },

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  emitChange(assessmentId) {
    this.emit(CHANGE_EVENT, assessmentId);
  },

  getCurrentLearnerId(){
    return _learnerId;
  },

  getRecentSessions(){
    return _recentSessions;
  },

  getLatestSessions(){
    return _latestSessions;
  },

  getMiscueTypes(){
    return _miscueTypes;
  },

  getMiscueYearGroups(onlyVisible){
    var self = this;
    return onlyVisible
      ? _miscueYearGroups.filter((group) => (!self.isHiddenYearGroup(group.code)))
      : _miscueYearGroups;
  },
  
  getSortedMiscueYearGroups(onlyVisible){
    return sortBy(this.getMiscueYearGroups(onlyVisible), ['code']);
  },

  getMiscueBookBands(){
    return _miscueBookBands;
  },

  getMiscueYearGroup(yearGroupId){
    var yearGroup = _miscueYearGroups.find((item) => (item.id == yearGroupId));
    return yearGroup || {};
  },

  isMiscueNoteRequired(miscueType){
    var miscueTypeItem = _miscueTypes.find((item) => {
      return item.code == miscueType
    });
    return miscueTypeItem
      ? miscueTypeItem.isNoteRequired
      : false;
  },

  getAssessmentDetails(assessmentId){
    return _assessmentDetails.hasOwnProperty(assessmentId)
      ? _assessmentDetails[assessmentId]
      : null;
  },

  updateAssessmentNote(assessmentId, note){
    if (!this.isAssessmentDetailsLoaded(assessmentId)) {
      return false;
    }
    _assessmentDetails[assessmentId].notes = note;
    return true;
  },

  updateMiscueItem(assessmentId, itemData){
    if (!this.isAssessmentDetailsLoaded(assessmentId)) {
      return false;
    }
    var miscueItem = _assessmentDetails[assessmentId].miscues.find((item) => {
      return item.id == itemData.id
    });
    assign(miscueItem, itemData);
    return true;
  },

  isAssessmentDetailsLoaded(assessmentId){
    return _assessmentDetails.hasOwnProperty(assessmentId)
      && _assessmentDetails[assessmentId];
  }

});


Dispatcher.register(function (action) {

  var assessmentId, miscueItem;

  switch (action.actionType) {
    case ActionType.MISCUE_SESSIONS_GET_RECENT:
      _learnerId = action.learnerId;

      if (action.appendRecords) {
        _recentSessions = _recentSessions.concat(action.miscueSessions);
      } else {
        _recentSessions = action.miscueSessions;
      }

      MiscueSessionStore.emitChange();
      break;

    case ActionType.MISCUE_SESSIONS_GET_LATEST:
      _latestSessions = action.miscueSessions;
      MiscueSessionStore.emitChange();
      break;

    case ActionType.MISCUE_SESSIONS_GET_ASSESSMENT_DETAILS:
      assessmentId = action.assessmentId;
      _assessmentDetails[assessmentId] = action.assessmentDetails;
      MiscueSessionStore.emitChange(assessmentId);
      break;

    case ActionType.MISCUE_SESSIONS_PATCH_ASSESSMENT_NOTE_SUCCESS:
      if (MiscueSessionStore.updateAssessmentNote(action.assessmentId, action.noteText)) {
        MiscueSessionStore.emitChange();
      }
      break;

    case ActionType.MISCUE_SESSIONS_PATCH_MISCUE:
      MiscueSessionStore.updateMiscueItem(action.assessmentId, action.miscueItem);
      MiscueSessionStore.emitChange();
      break;

    case ActionType.MISCUE_SESSIONS_DELETE_MISCUE:
      miscueItem = {
        id: action.miscueItemId,
        text: "",
        isDeleted: true
      };
      MiscueSessionStore.updateMiscueItem(action.assessmentId, miscueItem);
      MiscueSessionStore.emitChange();
      break;

    case ActionType.MISCUE_SESSIONS_GET_MISCUE_TYPES:
      _miscueTypes = action.miscueTypes;
      break;

    case ActionType.MISCUE_SESSIONS_GET_MISCUE_YEAR_GROUPS:
      _miscueYearGroups = action.miscueYearGroups;
      break;

    case ActionType.MISCUE_SESSIONS_GET_MISCUE_BOOK_BANDS:
      _miscueBookBands = action.miscueBookBands;
      break;

    case ActionType.MISCUE_SESSIONS_DELETE:

    default:


  }

});


module.exports = MiscueSessionStore;
